import React, { useEffect, useState } from "react";
import "./Admin_dashboard.css";
import "./GetUserDetails.css";
import { Underline, Floatinmenu } from "../../widgets";
import { admin_menu } from "../../constants/dashboard";
import axios from "axios";

export default function GetUserDetails() {
    const [regno, setRegno] = useState("");
    const [showResponse, setShowResponse] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        document.querySelector("input")?.focus();
    }, []);

    const handlegetuserdetails = async () => {
        if (!regno.trim()) {
            alert("Please enter a Registration Number");
            return;
        }

        setLoading(true);
        setShowResponse(false);
        setUserDetails(null);

        try {
            const res = await axios.post("backend/getstudentdetails", {
                reg_no: regno,
            });

            if (res.data.Status === "Success" && res.data.stud_details) {
                setUserDetails(res.data.stud_details);
            } else {
                setUserDetails(null);
            }
        } catch (err) {
            console.error(err);
            alert("Error fetching user details");
        } finally {
            setShowResponse(true);
            setLoading(false);
        }
    };

    const {
        studentname, regno: studentRegno, dob, gender, batch, programme,
        cgpa, mailid, phoneno, parent_no, hosteller,
        blood_grp, emis_no, regulation, student_type
    } = userDetails || {};

    // State for update section
    const [updateRegno, setUpdateRegno] = useState("");
    const [updateField, setUpdateField] = useState("");
    const [updateValue, setUpdateValue] = useState("");
    const [updateLoading, setUpdateLoading] = useState(false);
    const [updateMessage, setUpdateMessage] = useState("");

    const handleUpdate = async () => {
        if (!updateRegno.trim() || !updateField || !updateValue.trim()) {
            setUpdateMessage("Please fill all fields to update.");
            return;
        }
        setUpdateLoading(true);
        setUpdateMessage("");
        try {
            const res = await axios.post("backend/updatestudent", {
                regno: updateRegno,
                whattoUpdate: updateField,
                whatwithUpdate: updateValue,
            });
            if (res.data.Status === "Success") {
                setUpdateMessage("Updated successfully.");
            } else {
                setUpdateMessage("Update failed.");
            }
        } catch (err) {
            setUpdateMessage("Error updating user details.");
        } finally {
            setUpdateLoading(false);
            setUpdateValue("");
            setUpdateField("");
            setUpdateRegno("");
        }
    };

    return (
        <div className="user_details_container">
            <Floatinmenu head="Menu" links={admin_menu} />
            <Underline heading={"User details"} />
             
            <div className="user_details_content">
                <div className='user_details_main'>
                    <div className='UserDetails'>
                        <input
                            type="text"
                            placeholder="Enter the reg NO"
                            onChange={(e) => setRegno(e.target.value)}
                            value={regno}
                        />
                        <button
                            className="user_details_button"
                            onClick={handlegetuserdetails}
                        >
                            Search
                        </button>
                    </div>

                    {loading && <p>Loading...</p>}

                    {showResponse && !loading && (
                        userDetails ? (
                            <div className="response-details">
                                <h3>Student Details</h3>
                                <p><strong>Name:</strong> {studentname}</p>
                                <p><strong>Reg No:</strong> {studentRegno}</p>
                                <p><strong>DOB:</strong> {dob}</p>
                                <p><strong>Gender:</strong> {gender}</p>
                                <p><strong>Batch:</strong> {batch}</p>
                                <p><strong>Programme:</strong> {programme}</p>
                                <p><strong>CGPA:</strong> {cgpa}</p>
                                <p><strong>Mail ID:</strong> {mailid}</p>
                                <p><strong>Phone:</strong> {phoneno}</p>
                                <p><strong>Parent No:</strong> {parent_no}</p>
                                <p><strong>Hosteller:</strong> {hosteller}</p>
                                <p><strong>Blood Group:</strong> {blood_grp}</p>
                                <p><strong>EMIS No:</strong> {emis_no}</p>
                                <p><strong>Regulation:</strong> {regulation}</p>
                                <p><strong>Student Type:</strong> {student_type}</p>
                            </div>
                        ) : (
                            <p>No student record found.</p>
                        )
                    )}
                </div> 
            </div>
            <Underline heading="Update Data" />
            <div className="update_data_section">
                <input
                    type="text"
                    placeholder="Register Number"
                    value={updateRegno}
                    onChange={e => setUpdateRegno(e.target.value)}
                />
                <select
                    value={updateField}
                    onChange={e => setUpdateField(e.target.value)}
                >
                    <option value="">Select an option</option>
                    <option value="studentname">studentname</option>
                    <option value="student_type">student_type</option>
                    <option value="dob">dob</option>
                    <option value="regno">regno</option>
                    <option value="gender">gender</option>
                    <option value="phoneno">phoneno</option>
                    <option value="mailid">mailid</option>
                    <option value="hosteller">hosteller</option>
                    <option value="programme">programme</option>
                    <option value="regulation">regulation</option>
                    <option value="batch">batch</option>
                    <option value="parent_no">parent_no</option>
                    <option value="blood_grp">blood_grp</option>
                    <option value="emis_no">emis_no</option>
                </select>
                <input
                    type="text"
                    placeholder="Enter the Value"
                    value={updateValue}
                    onChange={e => setUpdateValue(e.target.value)}
                />
                <button onClick={handleUpdate} disabled={updateLoading}>
                    {updateLoading ? "Updating..." : "Update"}
                </button>
                {updateMessage && <p>{updateMessage}</p>}
            </div>
            <div className="logout_button">
            <a className="log_link" href="/logout">
              Logout
            </a>
            </div>
        </div>
    );
}
